/**
* Creates a fact provider function given the passed in config.
*/
export default function createFactProvider(
    config,
    baseFactProvider = () => {},
    frameworkFactProvider = () => {}) {
  return (prevState, action, nextState) => {
    if (!config || !config.enabled || !config.appId) {
      return null;
    }

    // Build the base information to apply to all facts.
    const baseFactInfo = {
      ...baseFactProvider(prevState, action, nextState),
      app_id: config.appId,
      ...(config.baseFactProvider ? config.baseFactProvider(prevState, action, nextState) : undefined)
    };

    // Get any facts generated from the framework and/or app specific facts.
    const facts = [];
    const frameworkFact = frameworkFactProvider(prevState, action, nextState);
    if (frameworkFact) {
      const isArray = frameworkFact instanceof Array;
      if (isArray && frameworkFact.length) {
        frameworkFact.forEach(fact => {
          facts.push({
            ...baseFactInfo,
            ...fact
          });
        });
      } else if (!isArray) {
        facts.push({
          ...baseFactInfo,
          ...frameworkFact
        });
      }
    }
    const appSpecificFact = config.factProvider && config.factProvider(prevState, action, nextState);
    if (appSpecificFact) {
      const isArray = appSpecificFact instanceof Array;
      if (isArray && appSpecificFact.length) {
        appSpecificFact.forEach(fact => {
          facts.push({
            ...baseFactInfo,
            ...fact
          });
        });
      } else if (!isArray) {
        facts.push({
          ...baseFactInfo,
          ...appSpecificFact
        });
      }
    }

    return facts;
  };
}
